import { CSSProperties } from 'react';

export const consistentAnimationDuration = (
  minDuration: number,
  index: number
): CSSProperties => ({
  transitionDuration: `${minDuration + index * 0.1}s`,
});
